import type { StatsManager } from './stats-manager';
import type { UserRepository } from '../data/user-repository';

export type FunnelTransitionDirection = 'initial' | 'forward' | 'backward';

export interface FunnelFlowDriver {
  goToNext(): void;
  goBack(): void;
  showScreen(screenName: string): void;
  getCurrentScreenName(): string;
  validateEmail(email: string): boolean;
}

export interface FunnelExperienceDependencies {
  userRepository: UserRepository;
  statsManager?: StatsManager;
  flow: FunnelFlowDriver;
}

/**
 * Optional treatment adapter. The control funnel never imports treatment code; `main.ts`
 * installs this adapter only after EarlyAbtestManager has selected the Modern experience.
 */
export interface FunnelExperience {
  readonly id: 'modern';
  readonly screens: readonly string[];
  readonly screenHashes: Readonly<Record<string, string>>;
  readonly paywallTemplateName: string;
  readonly emailScreenName: string;
  readonly rollingAssetPreload: boolean;
  init(deps: FunnelExperienceDependencies): void;
  onScreenShown(screen: HTMLElement, screenName: string): void;
  onBeforeScreenChange?(fromScreen: string, toScreen: string): void;
  getTransitionDirection(
    fromIndex: number,
    toIndex: number,
    hasActiveScreen: boolean
  ): FunnelTransitionDirection;
  updateMuteButton?(button: HTMLElement, muted: boolean): void;
}

let activeExperience: FunnelExperience | null = null;

export function registerFunnelExperience(experience: FunnelExperience): void {
  if (activeExperience && activeExperience !== experience) {
    throw new Error('A funnel experience is already registered for this page');
  }
  activeExperience = experience;
}

export function getActiveFunnelExperience(): FunnelExperience | null {
  return activeExperience;
}
